import React from 'react';
import { Typography } from '@lucid/lego';
import styles from './HeroHalf.module.scss';

interface HeroHalfProps {
  theme: 'light' | 'dark';
}

const HeroHalf: React.FC<HeroHalfProps> = ({ theme }) => {
  const imageUrl =
    'https://images.ctfassets.net/5ky6szwjj7ya/lucid-home-og.png/cddc89064c34590a2a7bb2a67ac1e2eb/lucid-home-og.png';

  return (
    <div className={styles.heroWrapper}>
      <div className={styles.heroContainer}>
        <img src={imageUrl} alt="Lucid Partner Portal Hero" className={styles.heroImage} />

        {/* Text Overlay */}
        <div className={styles.overlay}>
          <Typography variant="display" size="small" color="white" theme={theme}>
            Lucid Partner Portal
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default HeroHalf;
